import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=8808b2fc"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=8808b2fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports